// extracted by mini-css-extract-plugin
export default {"list":"Career_list__ZKdFo"};